import Ach from 'components/images/ach';
import AmericanExpress from 'components/images/americanExpress';
import ApplePay from 'components/images/applePay';
import Discover from 'components/images/discover';
import GooglePay from 'components/images/googlePay';
import StripeLink from 'components/images/link';
import MasterCard from 'components/images/masterCard';
import PayPal from 'components/images/payPal';
import Visa from 'components/images/visa';
import type { JSX } from 'react';
import { useAvailableWallets } from 'utils/store/availableWallets';
import { getPaymentMethod } from 'utils/store/paymentMethod';

import { usePaymentMethodsQuery } from '@/graphql/paymentMethods';

export function PaymentMethodImage() {
  const paymentMethod = getPaymentMethod();

  if (paymentMethod === 'payment_request') {
    return <PaymentRequest />;
  } else if (paymentMethod === 'paypal') {
    return <PayPal />;
  } else {
    return <StoredPaymentMethod id={parseInt(paymentMethod ?? '')} />;
  }
}

const paymentMethodImages: { [key: string]: JSX.Element } = {
  'American Express': <AmericanExpress />,
  Discover: <Discover />,
  MasterCard: <MasterCard />,
  Visa: <Visa />,
};

function StoredPaymentMethod({ id }: { id: number }) {
  const { data } = usePaymentMethodsQuery();
  const paymentMethod = data?.paymentMethods?.data?.find(pm => pm.id === id);

  if (!paymentMethod) {
    return null;
  }

  if (paymentMethod.paymentMethodType === 'Credit Card') {
    return paymentMethodImages[paymentMethod.paymentType];
  } else if (paymentMethod.paymentMethodType === 'ACH') {
    return <Ach />;
  }

  return null;
}

function PaymentRequest() {
  const { availableWallets } = useAvailableWallets();

  switch (true) {
    case availableWallets.applePay:
      return <ApplePay />;
    case availableWallets.googlePay:
      return <GooglePay />;
    case availableWallets.link:
      return <StripeLink />;
    default:
      return null;
  }
}
